export class Conferences {
  static AFC = 'AFC';
  static NFC = 'NFC';
}

export { CommonGamesMethodology } from '../shared/enums/nfl/common-games-methodology';
